import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Caisse } from '@modules/connexion/caisse-auto-complete/caisse';
import { crcaList } from '@modules/connexion/caisse-auto-complete/crca-list';
import { NGXLogger } from 'ngx-logger';
import { PasswordService } from '@kv-common-components/kx-services';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-password-logged-out-reset',
    templateUrl: './password-logged-out-reset.component.html',
    styleUrls: [],
})
export class PasswordLoggedOutResetComponent implements OnInit, OnDestroy {
    resetPasswordForm: FormGroup;
    apporteurPrincipal: string;
    idPersonne: string;
    apporteurSecondaire: string;
    token: string;
    selectedCaisse: Caisse;
    isLoading = false;
    submitLoading = false;
    sendSMSSuccess = false;
    passwordResetSuccess = false;

    queryParamsSubscription: Subscription;

    constructor(
        private logger: NGXLogger,
        private passwordService: PasswordService,
        private router: Router,
        private activatedRoute: ActivatedRoute
    ) {}

    ngOnInit(): void {
        const otpControl = new FormControl();
        otpControl.setValidators([
            Validators.maxLength(20),
            Validators.required,
        ]);
        this.resetPasswordForm = new FormGroup({});
        this.resetPasswordForm.addControl('otp', otpControl);
        this.queryParamsSubscription =
            this.activatedRoute.queryParams.subscribe((params) => {
                this.logger.debug('Reset Password infos received from url : ', {
                    params,
                });
                this.apporteurPrincipal = params.apporteurPrincipal;
                this.idPersonne = params.idPersonne;
                this.apporteurSecondaire = params.apporteurSecondaire;
                this.token = params.token;
                this.selectedCaisse = crcaList.find(
                    (x) => x.id === this.apporteurPrincipal
                );
                this.sendResetPasswordSms(false);
            });
    }

    ngOnDestroy() {
        if (this.queryParamsSubscription) {
            this.queryParamsSubscription.unsubscribe();
        }
    }

    // resend sms otp
    sendResetPasswordSms(manualCall: boolean) {
        this.passwordService
            .sendResetPasswordSms(
                this.idPersonne,
                this.apporteurPrincipal,
                this.apporteurSecondaire,
                this.token
            )
            .subscribe((response: any) => {
                this.logger.debug(
                    'Response from sendResetPasswordSms service : ',
                    { response }
                );
                if (manualCall) {
                    this.sendSMSSuccess = true;
                }
            });
    }

    // request actual reset
    submitResetPasswordForm() {
        if (
            this.resetPasswordForm.valid &&
            this.newPassword.value === this.repeatPassword.value
        ) {
            this.submitLoading = true;
            this.logger.debug(
                'ResetPasswordForm submitted for person: ',
                this.idPersonne,
                ' token : ',
                this.token
            );
            const requestBody = {
                tokenActivationWeb: this.token,
                otp: this.otp.value,
                motDePasse: this.newPassword.value,
                motDepasseConfirmation: this.newPassword.value,
            };
            this.passwordService
                .resetPasswordLoggedOutMode(
                    this.idPersonne,
                    this.apporteurPrincipal,
                    this.apporteurSecondaire,
                    requestBody
                )
                .subscribe(
                    (data: any) => {
                        this.logger.info(
                            'Password reset was successful: ',
                            data
                        );
                        this.submitLoading = false;
                        this.passwordResetSuccess = true;
                    },
                    (error) => {
                        this.submitLoading = false;
                        throw error;
                    }
                );
        }
    }

    goBackToLogin(): void {
        this.router.navigateByUrl('/connexion');
    }

    get otp() {
        return this.resetPasswordForm.get('otp');
    }

    get newPassword() {
        return this.resetPasswordForm.get('newPassword');
    }

    get repeatPassword() {
        return this.resetPasswordForm.get('repeatPassword');
    }
}
